/* istanbul ignore file */
import { RadioButtonGroup, RadioButtonGroupProps } from 'framework/form';
import { EMPLOYEE_CONTRACT_ASSIGMENT_TYPES } from 'domain/shared/employee';

const options = Object.keys(EMPLOYEE_CONTRACT_ASSIGMENT_TYPES).map(key => ({
  value: key,
  label: EMPLOYEE_CONTRACT_ASSIGMENT_TYPES[key],
}));

const EmployeeContractAssignmentTypeRadios = (props: RadioButtonGroupProps) => {
  return <RadioButtonGroup {...props} options={options} />;
};

export default EmployeeContractAssignmentTypeRadios;
